















import { Vue, Component, Prop, Watch } from "vue-property-decorator"

@Component
export default class extends Vue {
  @Prop({ default: true })
  value!: boolean

  @Prop({ default: true })
  closable!: boolean

  @Prop({ default: false })
  appear!: boolean

  showDialog = this.value

  animation = {}

  forceClose() {
    this.showDialog = false
    this.$nextTick(() => {
      this.$emit("input", false)
      const ev = new (class {
        stopCnt = 0
        stop() {
          ++this.stopCnt
        }
      })()
      this.$emit("close", ev)
      if (ev.stopCnt > 0) {
        this.showDialog = true
      }
    })
  }

  close() {
    if (this.closable) {
      this.forceClose()
    } else {
      this.shake()
    }
  }

  shake(cb?: () => void) {
    this.animation = { shake: true }
    if (cb) {
      this.shakeEndCallbacks.push(cb)
    }
  }

  shakeEnd() {
    while (this.shakeEndCallbacks.length > 0) {
      this.shakeEndCallbacks.shift()!()
    }
    this.animation = {}
  }

  shakeEndCallbacks: Array<() => void> = []

  @Watch("showDialog", { immediate: true })
  onShowChange() {
    if (this.showDialog) {
      this.$nextTick(() => {
        this.$emit("open")
      })
    }
  }
}
